import React from "react";
import './Secfive.css'

export default function () {
    return (

        <section className="sec-5 mt-5">   {/* section five start with content */}
            <h2 className="text-center">
                <span className="main-heading-sec-five  fw-bold ">Start Automatic Now </span>
            </h2>

            <div className="container">
                <div className="text-center">
                    <img src="images/auto-img.png" alt="" className="img-fluid" />
                    <p className="text-center pt-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniamLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim </p>
                </div>

                <div className="text-center pt-4">
                    <button type="button" className="sec-five-btn rounded p-3">
                        Register Now
                    </button>
                </div>

                <h2 className="text-center pt-5">
                    <span className="main-heading-sec-five  fw-bold">Testimonial</span>
                </h2>
            </div>

            <div className="container">

                <div className="row justify-content-between">
                    <div className="col-12 col-md-3 pt-5">
                        <div className="img-caption p-3">
                            <img src="images/client-1.jpg" alt="" className="rounded img-fluid " />
                            <h2 className="text-white pt-3 text-uppercase">Readable</h2>
                            <h4 className="text-white">Content of a page</h4>
                        </div>
                    </div>

                    <div className="col-12 col-md-8 pt-5">
                        <p className="text-dark lh-base fs-4">
                            It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem
                        </p>
                    </div>

                    <div className="col-12 col-md-3 pt-5">
                        <div className="img-caption p-3">
                            <img src="images/client-2.jpg" alt="" className="rounded img-fluid " />
                            <h2 className="text-white pt-3 text-uppercase">Readable</h2>
                            <h4 className="text-white">Content of a page</h4>
                        </div>
                    </div>

                    <div className="col-12 col-md-8 pt-5">
                        <p className="text-dark lh-base fs-4">
                            It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem
                        </p>
                    </div>

                </div>

                <div className="text-center pt-5">
                    <button type="button" className="sec-five-btn rounded  p-3">
                            Read More
                    </button>
                </div>

            </div>

        </section>

    )
}